module.exports = __webpack_public_path__ + "media/images/cardboard-img-04-fdd3d712c5276cdc926b7a4069a7e738.jpg";